import React, { useMemo } from 'react';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { buildFunctionalityIcons } from '~/FielderElements/SmartTaskTable/SmartTaskIconsUtils';
import { useLanguage } from 'Context/LanguageContext';

const SmartTaskFunctionalities = ({ forms, assets, inventory, functionalityIcons }) => {
	const lan = useLanguage();
	const icons = useMemo(
		() =>
			functionalityIcons ||
			buildFunctionalityIcons({ forms, assets, inventory }, lan),
		[functionalityIcons, forms, assets, inventory, lan]
	);
	return (
		<Grid container>
			{icons.map(({ text, icon, type }) => (
				<Grid pl={1} key={type}><Tooltip title={text}>{icon}</Tooltip></Grid>
			))}
		</Grid>
	);
};
export default SmartTaskFunctionalities;
